<template>
  <div class="datesnavigation">
    <TodayButton 
      @click="goToToday" />
    <div class="btnnavigator">
      <Chevprevious 
        @click="previousClicked"
        :hoverWithCircle="true"
        :hovercolor="'#f5f3f3'"
        :color="'#1976d2'"/>
      <Chevnext 
        @click="nextClicked"
        :hoverWithCircle="true"
        :hovercolor="'#f5f3f3'"
        :color="'#1976d2'"/>
    </div>
    <div class="weekviewer">
      {{ formattedDate }}
    </div>
  </div>
</template>

<script>
import TodayButton from '@/components/buttons/todayButton.vue'; 
import Chevnext from '@/components/buttons/chevnext.vue';
import Chevprevious from '@/components/buttons/chevprevious.vue';

export default {
  name: 'datesnavigation',
  props:["currentweek","monthNavigation"],
  inject:["lang"],
  emits:["setWeek"],
  components:{
    TodayButton,
    Chevnext,
    Chevprevious
  },
  computed:{
    monthDate(){
      const formatter = new Intl.DateTimeFormat("pt-PT", {
        month: "long",
        year: "numeric"
      });
      return formatter.format(this.currentweek.start);
    },
    startdate(){
      if(this.currentweek.start == null){
        return ""
      }
      return this.formatDate(this.currentweek.start,false);
    },
    enddate(){
      if(this.currentweek.end == null){
        return ""
      }
      return this.formatDate(this.currentweek.end,true);
    },
    formattedDate(){
      if(this.isStartAndEndOfMonth()){
        return this.monthDate;
      }
      return `${this.startdate} - ${this.enddate}`
    }
  },
  methods: {
    isStartAndEndOfMonth() {
      const isStart = this.currentweek.start .getDate() === 1;
      const nextDay = new Date(this.currentweek.end.getTime());
      nextDay.setDate(nextDay.getDate() + 1);
      const isEnd = this.currentweek.end.getMonth() !== nextDay.getMonth();
      const isSameMonth = this.currentweek.start .getFullYear() === this.currentweek.end.getFullYear() &&
                         this.currentweek.start .getMonth() === this.currentweek.end.getMonth();
      return isStart && isEnd && isSameMonth;
    },
    formatDate(date, includeYear = false) {
      const day = String(date.getDate()).padStart(2, '0');
      const monthIndex = date.getMonth();
      const shortMonths = [ 'jan.', 'fev.', 'mar.', 'abr.','mai.',
        'jun.', 'jul.', 'ago.', 'set.',  'out.', 'nov.', 'dez.' ];
      const shortMonthsEn = [ 'jan.','feb.','mar.','apr.','may','jun.',
        'jul.','aug.','sep.','oct.','nov.','dec.' ];
      let month = this.lang == "pt" ? shortMonths[monthIndex] : shortMonthsEn[monthIndex] ;
      if (includeYear) {
        const year = date.getFullYear();
        return `${day} ${month} ${year}`;
      } else {
        return `${day} ${month}`;
      }
    },
    previousClicked(){
      if(this.monthNavigation){
        this.goToPreviousMonth();
      }else{
        this.goToPreviousWeek();
      }
    },
    nextClicked(){
      if(this.monthNavigation == true){
        this.goToNextMonth();
      }else{
        this.goToNextWeek();
      }
    },
    goToToday(){
      var today = new Date();
      var startDate, endDate;
      if (this.monthNavigation) {
          startDate = new Date(today.getFullYear(), today.getMonth(), 1);
          endDate = new Date(today.getFullYear(), today.getMonth() + 1, 0);
      } else {
          startDate = new Date(today.setDate(today.getDate() - today.getDay() + 1));
          endDate = new Date(startDate);
          endDate.setDate(endDate.getDate() + 6);
      }
      this.changeDate(startDate, endDate);
    },
    goToPreviousMonth(){
      let startDate = new Date(this.currentweek.start);
      startDate.setMonth(startDate.getMonth() - 1);
      startDate.setDate(1);
      let endDate = new Date(startDate);
      endDate.setMonth(endDate.getMonth() + 1);
      endDate.setDate(0);
      this.changeDate(startDate,endDate);
    },
    goToNextMonth(){
      let startDate = new Date(this.currentweek.start);
      startDate.setMonth(startDate.getMonth() + 1);
      startDate.setDate(1);
      let endDate = new Date(startDate);
      endDate.setMonth(endDate.getMonth() + 1);
      endDate.setDate(0);
      this.changeDate(startDate,endDate);
    },
    goToPreviousWeek(){
      let startDate = new Date(this.currentweek.start);
      startDate.setDate(startDate.getDate() - 7);
      let endDate = new Date(startDate);
      endDate.setDate(endDate.getDate() + 6);
      this.changeDate(startDate,endDate);
    },
    goToNextWeek(){
      let startDate = new Date(this.currentweek.start);
      startDate.setDate(startDate.getDate() + 7);
      let endDate = new Date(startDate);
      endDate.setDate(endDate.getDate() + 6);
      this.changeDate(startDate,endDate);
    },
    changeDate(startDate,endDate){
      this.$emit("setWeek",{
        "start":startDate,
        "end": endDate
      });
    },
  }
}
</script>

<style scoped>
.datesnavigation{
  display: flex;
  flex-direction: row;
}

.btnnavigator{
  margin-left: 25px;
  margin-right: 25px;
  width: 70px;  
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.weekviewer{
  font-family: "Montserrat";
  font-size: 25px;
}


</style>